<template>
    <div>

        <!--Beware, water-sources can be empty -->
        <dataset-filter-select
            :general-entities="generalEntities"
            :entity-key-word-index="entityKeyWordIndex"
            :pipes="pipes"
            :hand-pumps="handPumps"
            :springs="springs"
            :provinces="provinces"
            :pre-selected="null"
            @change:id="(id) => identitiesArray = id"
            @change:model="(model) => modelsArray = model" >
        </dataset-filter-select>

        <div class="btn btn-block btn-primary border border-dark my-4" @click="getDataSets">Obtain datasets</div>

        <article class="table-responsive">
            <table class="table table-borderless">

                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Owner</th>
                        <th>Collected about</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, numericIndex) of dataSetArray">
                        <td>{{ numericIndex }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.data_set_type.name }}</td>
                        <td>{{ displayOwner(item)  }}</td>
                        <td>{{ item.entity.name }}</td>
                        <td>

                            <a
                                class="btn btn-sm btn-info border border-dark"
                                :href="appUrl + '/data-collection/data-set/' + item.id "
                                v-if="item.active && userPermissions.view" >
                                View
                            </a>

                            <span v-if="userPermissions.edit">
                                <a
                                    class="btn btn-sm btn-primary border border-dark"
                                    :href=" appUrl + '/data-collection/data-set/' + item.id + '/edit' "
                                    v-if="item.active" >
                                    Edit
                                </a>

                                <div class="btn btn-sm btn-danger border border-dark" @click="disableDataset(item.id)" v-if="item.active"> Disable </div>

                                <div class="btn btn-sm btn-danger border border-dark" @click="enableDataset(item.id)" v-else> Enable </div>
                            </span>

                        </td>
                    </tr>
                </tbody>

            </table>
        </article>

    </div>
</template>

<script>
export default{
    props : {

        generalEntities : {
            type : Object,
            required : true
        },

        entityKeyWordIndex : {
            type : Array,
            required : true
        },

        pipes : {
            type : Array,
            required : true,
        },

        handPumps : {
            type : Array,
            required : true,
        },

        springs : {
            type : Array,
            required : true,
        },

        provinces : {
            type : Array,
            required : true
        },

        userPermissions : {
            type : Object,
            required : true
        }

    },

    data(){
        return {
            dataSetArray: [],
            identitiesArray: [],
            modelsArray: [],
            appUrl: window.APP_URL,
        };
    },

    methods : {

        getDataSets() {
            // This JSON will become an associative array on server's side thus passing array validation
            let data = {
                ids: this.identitiesArray,
                models: this.modelsArray
            }

            window.axios.post(`${APP_URL}/data-set/filtered`, {data})
                .then((response) => { this.dataSetArray = response.data; })
                .catch((error) => { window.console.error(error); });
        },

        /* Error 405 occurs, cause of wrong data format
           But since I can, I will simply not print error, and reload in the end to make it appear
           like there is no error at all. Feels like cheating though. */
        enableDataset(identity) {
            window.axios.delete(window.APP_URL + "/data-collection/data-set/" + identity + "/enable")
                .then((response) => { this.updateDataSet(identity, true); })
                .catch((error) => { window.console.error(error); })
        },

        // same as above applies to this method too.
        disableDataset(identity) {
            window.axios.delete(window.APP_URL + "/data-collection/data-set/" + identity + "/disable")
                .then((response) => { this.updateDataSet(identity, false); })
                .catch((error) => { window.console.error(error); })
        },

        updateDataSet(identity, isEnabled) {
            for (let item of this.dataSetArray) {
                if (item.id === identity) {
                    item.active = isEnabled;
                    break;
                }
            }
        },

        displayOwner(item)
        {
            if (item.owner === null)
                return 'undefined';

            return item.owner.name;
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-set/AjaxDataSetWrapper.vue